import { useNavigate } from "react-router-dom";
import { TypeAnimation } from "react-type-animation";
import { useContextHook } from "../../Context/ContextOPen";
import {
  Col,
  ContactIcons,
  Container,
  MainButton,
  Row,
} from "../../components";
import { content } from "../../lang/useLang";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { heroImag } from "../../Context/Lists";

const Hero = () => {
  const naviget = useNavigate();
  const { swiperIndex, direction, setSwiperIndex } = useContextHook();

  return (
    <div
      className="min-h-screen hero bg-gradient-to-br from-purple-900 via-blue-900 to-cyan-900 relative overflow-hidden"
      style={{ direction }}
    >
      <br />
      {/* خلفية متحركة فريدة */}
      <div className="absolute inset-0 overflow-hidden">
        {/* دوائر متحركة */}
        <div className="absolute top-1/4 -left-10 w-72 h-72 bg-purple-500/10 rounded-full blur-3xl animate-orbital-1"></div>
        <div className="absolute bottom-1/4 -right-10 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl animate-orbital-2"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-blue-500/5 rounded-full blur-3xl animate-pulse-glow"></div>

        {/* شبكة متحركة */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-purple-500/20 to-transparent animate-shimmer"></div>
        </div>

        {/* جسيمات نجوم */}
        <div className="absolute inset-0">
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className="absolute w-1 h-1 bg-white rounded-full animate-twinkle"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${3 + Math.random() * 4}s`,
              }}
            ></div>
          ))}
        </div>
      </div>

      <Container className="relative z-10">
        <Row className="items-center min-h-screen">
          {/* النص الرئيسي */}
          <Col md={6} className="space-y-8 relative">
            {/* تأثير خلفي للنص */}
            <div className="absolute -inset-6 bg-gradient-to-r from-purple-500/5 to-cyan-500/5 rounded-3xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-1000"></div>

            <div
              className={`relative transition-all duration-1000 ${
                swiperIndex === 0 || !swiperIndex
                  ? "opacity-100 translate-x-0"
                  : "opacity-0 -translate-x-10"
              }`}
            >
              {/* الترحيب */}
              <div
                className="text-4xl max-sm:text-2xl font-bold mb-4 text-white animate-fade-in-up"
                style={{ animationDelay: "200ms" }}
              >
                {content.WelcomeTo}
              </div>

              {/* العنوان المتحرك */}
              <div
                className="text-2xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-cyan-300 to-purple-300 animate-fade-in-up"
                style={{ animationDelay: "400ms" }}
              >
                {content.OurServices + " "}
                <div className="lg:hidden"></div>
                {content.services_1 && content.services_2 && (
                  <TypeAnimation
                    sequence={[
                      content.services_1,
                      2000,
                      content.services_2,
                      2000,
                      content.services_3,
                      2000,
                      content.services_4,
                      2000,
                    ]}
                    wrapper="span"
                    speed={60}
                    style={{
                      fontSize: "1em",
                      background: "linear-gradient(135deg, #67e8f9, #a855f7)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                    repeat={Infinity}
                  />
                )}
              </div>

              {/* الوصف */}
              <p
                className="leading-7 text-lg mb-6 text-gray-200 animate-fade-in-up"
                style={{ animationDelay: "600ms" }}
              >
                {content.heroDescription}
              </p>

              {/* أيقونات التواصل */}
              <div
                className="animate-fade-in-up"
                style={{ animationDelay: "800ms" }}
              >
                <ContactIcons index={0} />
              </div>

              {/* الزر الرئيسي */}
              <div
                className="animate-fade-in-up"
                style={{ animationDelay: "1000ms" }}
              >
                <MainButton
                  onClick={() => {
                    naviget("/contact-us");
                    setSwiperIndex(4);
                  }}
                  name={content.contact_us}
                  className="my-4 transform hover:scale-105 transition-transform duration-300"
                  index={0}
                />
              </div>
            </div>
          </Col>

          {/* الصورة */}
          <Col md={6} className="flex justify-center items-center relative">
            {/* <Swiper
              style={{ direction: "ltr" }}
              modules={[Pagination, Autoplay]}
              pagination={{ clickable: true }}
              autoplay={{ delay: 3000 }}
              loop={true}
              className="w-full h-full"
            >
              {heroImag.map((e, i) => (
                <SwiperSlide key={i}>
                  <img
                    src={e}
                    alt=""
                    className="w-full h-[40vh] object-cover rounded-xl"
                  />
                </SwiperSlide>
              ))}
            </Swiper> */}
          </Col>
        </Row>
      </Container>

      {/* الأنيميشن المخصصة */}
      <style jsx>{`
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes orbital-1 {
          0%,
          100% {
            transform: translate(0, 0) rotate(0deg);
          }
          25% {
            transform: translate(50px, -30px) rotate(90deg);
          }
          50% {
            transform: translate(0, -60px) rotate(180deg);
          }
          75% {
            transform: translate(-50px, -30px) rotate(270deg);
          }
        }
        @keyframes orbital-2 {
          0%,
          100% {
            transform: translate(0, 0) rotate(0deg);
          }
          25% {
            transform: translate(-40px, 20px) rotate(-90deg);
          }
          50% {
            transform: translate(0, 40px) rotate(-180deg);
          }
          75% {
            transform: translate(40px, 20px) rotate(-270deg);
          }
        }
        @keyframes pulse-glow {
          0%,
          100% {
            opacity: 0.1;
            transform: scale(1);
          }
          50% {
            opacity: 0.3;
            transform: scale(1.1);
          }
        }
        @keyframes shimmer {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }
        @keyframes twinkle {
          0%,
          100% {
            opacity: 0.3;
            transform: scale(1);
          }
          50% {
            opacity: 1;
            transform: scale(1.2);
          }
        }
        @keyframes spin-slow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        @keyframes spin-slow-reverse {
          from {
            transform: rotate(360deg);
          }
          to {
            transform: rotate(0deg);
          }
        }
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
          opacity: 0;
        }
        .animate-orbital-1 {
          animation: orbital-1 20s ease-in-out infinite;
        }
        .animate-orbital-2 {
          animation: orbital-2 25s ease-in-out infinite;
        }
        .animate-pulse-glow {
          animation: pulse-glow 8s ease-in-out infinite;
        }
        .animate-shimmer {
          animation: shimmer 3s ease-in-out infinite;
        }
        .animate-twinkle {
          animation: twinkle 3s ease-in-out infinite;
        }
        .animate-spin-slow {
          animation: spin-slow 20s linear infinite;
        }
        .animate-spin-slow-reverse {
          animation: spin-slow-reverse 25s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default Hero;
